import Kr from "./kr";
import En from "./en";

export default function LanguageSet() {
	var languageSet = {
		kr: Kr(),
		en: En(),
	};

	return languageSet;
}
